import { useNavigate } from 'react-router-dom'
import { Users, Crown, MapPin } from 'lucide-react'

const sections = [
  { title: 'Mapa de Eleitores', description: 'Visualize a distribuição de eleitores por bairro e cidade', icon: Users, path: '/reports/map/voters' },
  { title: 'Mapa de Lideranças', description: 'Visualize as áreas de atuação das lideranças', icon: Crown, path: '/reports/map/leaders' },
  { title: 'Mapa de Seções', description: 'Seções eleitorais com engajamento e quantidade de eleitores', icon: MapPin, path: '/reports/map/sections' },
]

export default function ReportsMapPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Mapa Eleitoral</h1>
        <p className="text-gray-500 mt-1">Visualize a distribuição geográfica da sua base</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {sections.map(section => {
          const Icon = section.icon
          return (
            <div
              key={section.title}
              onClick={() => navigate(section.path)}
              className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-sm transition-shadow cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-brand-50 text-brand-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{section.title}</h3>
                  <p className="text-sm text-gray-500 mt-1">{section.description}</p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
